import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b4b30ff4&"
import script from "./main.vue?vue&type=script&lang=coffee&"
export * from "./main.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports